import { LayoutHOC } from 'base/ui/layout/layout';
import { IPurchaseOrderServices } from 'services/Main/purchaseOrder_services';
import createReceiveSchedule3 from '.';

export const createReceiveSchedule3Page = (layoutHOC: LayoutHOC, services: IPurchaseOrderServices) => {
  return layoutHOC(createReceiveSchedule3(services));
};
